import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { veneersGuideArticle } from '../../data/blog/veneersGuideArticle';
export function VeneersGuideArticle() {
  return <BlogArticleTemplate article={veneersGuideArticle} data-id="element-807" data-mp="251hmdqqyhacf" />;
}